var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',_vm._l((_vm.tableColumns),function(tableColumn,key){return _c('th',{key:key,staticClass:"border-top-0 p-2",attrs:{"scope":"col"}},[_vm._v("\n\n            "+_vm._s(_vm.$t(tableColumn.title))+"\n\n        ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }